/**
 * Shared year-range helpers for historical coverage/application dropdowns.
 */

export const HISTORICAL_YEAR_LOWER_BOUND = 2022;

/** Fixed upper bound for CAP historical applications/enrollments pages. */
export const HISTORICAL_YEAR_UPPER_BOUND = 2025;

/**
 * Returns year strings from `fromYear` down to `toYear` (inclusive), descending.
 * Returns [] when inputs are invalid or fromYear < toYear.
 */
export const getYearsDescending = (
    fromYear: number | string | null | undefined,
    toYear: number | string = HISTORICAL_YEAR_LOWER_BOUND,
): string[] => {
    const start = Number(fromYear);
    const end = Number(toYear);

    if (!Number.isFinite(start) || !Number.isFinite(end) || start < end) {
        return [];
    }

    return Array.from({ length: start - end + 1 }, (_, i) => (start - i).toString());
};

/**
 * Enrollment listing dropdown when historical data is enabled:
 * normal coverage years plus historical years (currentCoverageYear down to 2022).
 */
export const getCoverageYearsWithHistorical = (
    currentCoverageYear: number | string | null | undefined,
): string[] => getYearsDescending(currentCoverageYear, HISTORICAL_YEAR_LOWER_BOUND);

/**
 * CAP historical applications/enrollments pages: fixed 2025 down to 2022.
 */
export const getHistoricalYears = (): string[] =>
    getYearsDescending(HISTORICAL_YEAR_UPPER_BOUND, HISTORICAL_YEAR_LOWER_BOUND);
